import { useMutation, useQuery } from 'react-query';
import { getAuth } from '@firebase/auth';

const { REACT_APP_CAROLIVE_V3_URL: API_URL } = process.env;

export const HAR_GITS_RECALLS_KEY = 'har-gits-recalls';
export const SUZUKI_GARANTIE_PRO_KEY = 'suzuki-garantie-pro';
export const SERVICE_CAMPAIGN_VOUCHERS_KEY = 'service-campaign-vouchers';

const fetchGitsHarRecalls = async vin => {
	const token = await getAuth().currentUser.getIdToken();

	const res = await fetch(`${API_URL}/${HAR_GITS_RECALLS_KEY}/v1/by-vin?vin=${vin}`, {
		method: 'get',
		headers: { 'firebase-token': token },
	});
	const data = await res.json();

	if (data.success === false) throw new Error('Failed to fetch GITS HAR recalls', { cause: data });

	return data.data;
};

export const useFetchGitsHarRecalls = (vin, options = {}) => {
	return useQuery([HAR_GITS_RECALLS_KEY, vin], () => fetchGitsHarRecalls(vin), {
		retry: false,
		refetchOnMount: false,
		refetchOnReconnect: false,
		refetchOnWindowFocus: false,
		...options,
	});
};

const downloadSuzukiGarantiePro = async devizId => {
	const token = await getAuth().currentUser.getIdToken();

	const res = await fetch(`${API_URL}/v1/suzuki/garantie-pro?workOrderId=${devizId}`, {
		method: 'get',
		headers: { 'firebase-token': token },
	});

	if (!res.ok) {
		const error = await res.json();
		throw new Error(error.message);
	}

	return await res.blob();
};

export const useDownloadSuzukiGarantiePro = () => {
	return useMutation(({ devizId }) => downloadSuzukiGarantiePro(devizId));
};

const performRecall = async (id, orderId) => {
	const token = await getAuth().currentUser.getIdToken();

	const res = await fetch(`${API_URL}/${HAR_GITS_RECALLS_KEY}/v1`, {
		method: 'post',
		headers: { 'firebase-token': token },
		body: JSON.stringify({ id, workOrderId: orderId }),
	});

	const data = await res.json();

	if (data.success === false) throw new Error('Failed to perform recall', { cause: data });

	return data;
};

export const usePerformRecallMutation = () => {
	return useMutation(({ id, orderId }) => performRecall(id, orderId));
};

const fetchCampaignByWorkOrder = async workOrderId => {
	const token = await getAuth().currentUser.getIdToken();

	const res = await fetch(`${API_URL}/${SERVICE_CAMPAIGN_VOUCHERS_KEY}/v1/by-work-order?workOrderId=${workOrderId}`, {
		method: 'get',
		headers: { 'firebase-token': token },
	});
	const data = await res.json();

	if (data.success === false) throw new Error('Failed to fetch campaign by work order', { cause: data });

	return data.data;
};

export const useFetchCampaignByWorkOrder = (workOrderId, options = {}) => {
	return useQuery([SERVICE_CAMPAIGN_VOUCHERS_KEY, workOrderId], () => fetchCampaignByWorkOrder(workOrderId), {
		retry: false,
		staleTime: 0,
		...options,
	});
};

const generateCampaignVoucher = async workOrderId => {
	const token = await getAuth().currentUser.getIdToken();

	const res = await fetch(`${API_URL}/${SERVICE_CAMPAIGN_VOUCHERS_KEY}/v1/use?workOrderId=${workOrderId}`, {
		method: 'post',
		headers: { 'firebase-token': token },
	});
	const data = await res.json();

	if (data.success === false) throw new Error('Failed to generate campaign voucher', { cause: data });

	return data.data;
};

export const useGenerateCampaignVoucherMutation = () => {
	return useMutation(({ workOrderId }) => generateCampaignVoucher(workOrderId));
};
